/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Smile: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M512 56.889344c251.35104 0 455.110656 203.759616 455.110656 455.110656S763.35104 967.110656 512 967.110656 56.889344 763.35104 56.889344 512 260.64896 56.889344 512 56.889344z m227.95264 487.328768c-15.868928-5.608448-33.28 2.70848-38.889472 18.578432-27.74528 78.497792-102.20032 132.06016-186.830848 132.06016-84.631552 0-159.086592-53.562368-186.831872-132.06016-5.608448-15.869952-23.01952-24.18688-38.889472-18.578432-15.869952 5.609472-24.18688 23.020544-18.578432 38.890496 36.288512 102.670336 133.635072 172.700672 244.299776 172.700672 110.66368 0 208.01024-70.03136 244.298752-172.700672 5.609472-15.869952-2.70848-33.281024-18.577408-38.890496zM355.331072 353.523712c-26.9312 0-48.76288 21.83168-48.76288 48.76288 0 26.929152 21.83168 48.760832 48.76288 48.760832 26.930176 0 48.761856-21.83168 48.761856-48.761856 0-26.9312-21.83168-48.761856-48.76288-48.761856z m316.049408 0c-26.9312 0-48.76288 21.83168-48.76288 48.76288 0 26.929152 21.83168 48.760832 48.76288 48.760832 26.930176 0 48.761856-21.83168 48.761856-48.761856 0-26.9312-21.83168-48.761856-48.76288-48.761856z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Smile.defaultProps = {
  size: 18,
};

Smile = React.memo ? React.memo(Smile) : Smile;

export default Smile;
